<template>
  <div data-dusk="detailed-customer-select-component">
    <div class="flex-row justify-content-center gap-md container-h-xl">
      <div v-if="searchType === CustomerSearchTypeEnum.name" class="flex-row justify-content-center gap-md flex-stretch">
        <dd-input
            id="detailed-customer-search-input"
            v-model="query"
            style="flex: 0.7"
            placeholder="Achternaam"
            @input="handleInput"
        />
        <dd-input
            v-model="second_query"
            style="flex: 0.3"
            placeholder="Voorletters"
            @input="handleInput"
        />
      </div>

      <div v-else-if="searchType === CustomerSearchTypeEnum.postal_code" class="flex-row justify-content-center gap-md flex-stretch">
        <dd-input
            v-model="query"
            style="flex: 0.7"
            placeholder="Postcode"
            @input="handleInput"
        />
        <dd-input
            v-model="second_query"
            style="flex: 0.3"
            placeholder="Huisnummer (optioneel)"
            @input="handleInput"
        />
      </div>

      <dd-select
        v-else-if="searchType === CustomerSearchTypeEnum.label"
        v-model="query"
        :options="productLabelOptions"
        placeholder="Zoek op label"
        class="flex-stretch"
        @input="handleSearch"
      />

      <dd-date-picker
        v-else-if="searchType === CustomerSearchTypeEnum.dob"
        v-model="query"
        placeholder="Zoek op geboortedatum (dd-mm-yyyy)"
        class="flex-stretch"
        @input="handleSearch"
        :valueFormat="DateFormatsEnum.DISPLAY_DATE"
      />

      <dd-input
          v-else
          id="match-customer-extended-search-input"
          class="flex-stretch"
          v-model="query"
          :placeholder="`Zoeken op ${searchTypeDescriptionByCategory()}`"
          @input="handleInput"
      />

      <dd-dropdown-button-list
          title="Zoekopties"
          :options="searchTypeOptions"
      />
    </div>

    <div v-if="loading" class="width-stretch flex-row justify-content-center mt-xl">
      <dd-loading-indicator/>
    </div>

    <div v-else class="border-radius-sm mt-md overflow-hidden">
      <dd-main-table
          id="detailed-customer-search-table"
          v-if="foundCustomers.length > 0"
          :headers="headers[headerCategory]"
          :rows="foundCustomers"
          :has-select="true"
          :single-select="true"
          :entire-row-selects="true"
          :selected="[selectedCustomerId]"
          @update-selected="handleSelectedCustomer"
      ></dd-main-table>
    </div>
  </div>
</template>
<script>
import CustomerApi from "~/api/customer";
import MortgageApi from "~/api/mortgage";
import PolicyApi from "~/api/policy";
import ProductLabelApi from '~/api/product_label';

import CustomerCell from "../cell_types/CustomerCell.vue";
import AddressCell from "../cell_types/AddressCell.vue";
import ContactInfoCell from "../cell_types/ContactInfoCell.vue";
import ContractNumberCell from "~/pages/insurance/index/components/cell_types/ContractNumber.vue";

import {CategoryEnum} from "~/enums";
import CustomerSearchTypeEnum from '~/enums/searchTypes/customer/types'
import CustomerSearchTypeDisplayEnum from '~/enums/searchTypes/customer/display'
import DateFormatsEnum from "~/new_design_components/enums/DateFormatsEnum";

import MortgageSearchTypeEnum from '~/enums/searchTypes/mortgage/types'
import MortgageSearchTypeDisplayEnum from '~/enums/searchTypes/mortgage/display'
import PolicySearchTypeEnum from '~/enums/searchTypes/policy/types'
import PolicySearchTypeDisplayEnum from '~/enums/searchTypes/policy/display'
import MortgageNumberCell from "~/pages/components/cell_types/MortgageNumberCell.vue";

export default {
  name: "DetailedCustomerSelectComponent.vue",
  data(){
    return {
      loading: false,
      foundCustomers: [],
      selectedCustomerId: undefined,
      headers: {
        [CategoryEnum.CUSTOMER]: [
          {title: 'Naam', key: (row) => row, typeComponent: CustomerCell, width: '33%'},
          {title: 'Adres', key: (row) => row.current_visit_customer_property?.data?.property?.data, typeComponent: AddressCell, width: '33%'},
          {title: 'Contact', key: 'email_address', typeComponent: ContactInfoCell, width: '33%'}
        ],
        [CategoryEnum.MORTGAGE]: [
          {title: 'Hypotheeknummer', key: (row) => row.mortgage?.hypotheeknummer, typeComponent: MortgageNumberCell, width: '33%'},
          {title: 'Naam', key: (row) => row, typeComponent: CustomerCell, width: '33%'},
          {title: 'Adres', key: (row) => row.current_visit_customer_property?.data?.property?.data, typeComponent: AddressCell, width: '33%'},
        ],
        [CategoryEnum.INSURANCE]: [
          {title: 'Polisnummer', key: (row) => row.policy?.contract_number, typeComponent: ContractNumberCell, width: '33%'},
          {title: 'Naam', key: (row) => row, typeComponent: CustomerCell, width: '33%'},
          {title: 'Adres', key: (row) => row.current_visit_customer_property?.data?.property?.data, typeComponent: AddressCell, width: '33%'},
        ],
      },
      headerCategory: CategoryEnum.CUSTOMER,
      searchType: CustomerSearchTypeEnum.name,
      searchCategory: CategoryEnum.CUSTOMER,
      query: '',
      second_query: '',
      productLabels: undefined,
    }
  },
  methods: {
    searchTypeDescriptionByCategory(){
      switch(this.searchCategory){
        case CategoryEnum.CUSTOMER:
          return CustomerSearchTypeDisplayEnum[this.searchType].toLowerCase();
        case CategoryEnum.MORTGAGE:
          return MortgageSearchTypeDisplayEnum[this.searchType].toLowerCase();
        case CategoryEnum.INSURANCE:
          return PolicySearchTypeDisplayEnum[this.searchType].toLowerCase();
      }
    },
    setSearchTypeAndCategory(type, category){
      this.searchType = type;
      this.searchCategory = category;
      this.query = '';
      this.second_query = '';
      if (this.searchType === CustomerSearchTypeEnum.label) this.getProductLabels();
    },
    handleInput() {
      this.debounce(this.handleSearch)();
    },
    debounce(func, timeout = 500) {
      return () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(func, timeout);
      };
    },
    async handleSearch(){
      if ( !this.query && !this.second_query) return;
      this.loading = true;

      let request;
      switch(this.searchCategory){
        case CategoryEnum.CUSTOMER:
          request = CustomerApi.detailedSearch(
              this.query,
              this.second_query,
              this.searchType,
              25,
              ['current_visit_customer_property.property', 'product_labels']
          );
          break;
        case CategoryEnum.MORTGAGE:
          request = MortgageApi.detailedSearch(
              this.query,
              this.second_query,
              this.searchType,
              25,
              ['customer.current_visit_customer_property.property', 'customer.product_labels']
          );
          break;
        case CategoryEnum.INSURANCE:
          request = PolicyApi.detailedSearch(
              this.query,
              this.second_query,
              this.searchType,
              25,
              ['customer.current_visit_customer_property.property', 'customer.product_labels']
          );
          break;
      }

      const data = this.transformResultsToCustomerFirst(await request);

      if ( this.selectedCustomerId ){
        const selectedId = this.selectedCustomerId;
        this.foundCustomers = [
          this.customer,
          ...data.filter(customer => String(customer.id) !== String(selectedId))
        ];
        this.$nextTick(() => this.$set(this, 'selectedCustomerId', selectedId));
      } else {
        this.foundCustomers = data;
      }
      this.headerCategory = this.searchCategory;
      this.loading = false;
    },
    transformResultsToCustomerFirst(results){
      if (this.searchCategory === CategoryEnum.MORTGAGE){
        return results.data.map(data => {
          const newData = {
            ...data.customer.data
          };
          newData.mortgage = { ...data, customer: undefined};
          return newData;
        });
      } else if (this.searchCategory === CategoryEnum.INSURANCE){
        return results.data.map(data => {
          const newData = {
            ...data.customer.data
          };
          newData.policy = { ...data, customer: undefined}
          return newData;
        });
      }
      return results.data;
    },
    async handleSelectedCustomer(selected){
      if ( selected !== this.selectedCustomerId ){
        this.$set(this, 'selectedCustomerId', selected);
        this.$emit('input', this.customer);
      }
    },
    getProductLabels(){
      if (this.productLabels) return;
      ProductLabelApi.getByProductCategory('customer', 'name', 'desc', 999)
          .then(({data}) => {
            this.productLabels = data;
          })
    }
  },
  computed: {
    DateFormatsEnum() {
      return DateFormatsEnum;
    },
    customer(){
      return this.foundCustomers.find(customer => customer.id === this.selectedCustomerId);
    },
    CustomerSearchTypeEnum(){
      return CustomerSearchTypeEnum;
    },
    searchTypeOptions() {
      return {
        Klanten: Object.keys(CustomerSearchTypeEnum).map(type => {
          return {
            title: CustomerSearchTypeDisplayEnum[type],
            click: () => this.setSearchTypeAndCategory(type, CategoryEnum.CUSTOMER)
          }
        }),
        Hypotheken: Object.keys(MortgageSearchTypeEnum).map(type => {
          return {
            title: MortgageSearchTypeDisplayEnum[type],
            click: () => this.setSearchTypeAndCategory(type, CategoryEnum.MORTGAGE)
          }
        }),
        Polissen: Object.keys(PolicySearchTypeEnum).map(type => {
          return {
            title: PolicySearchTypeDisplayEnum[type],
            click: () => this.setSearchTypeAndCategory(type, CategoryEnum.INSURANCE)
          }
        })
      };
    },
    productLabelOptions() {
     return this.productLabels?.map(label => ({
       label: label.name,
       value: label.id,
     }));
    }
  }
}

</script>

